import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import Grid from '../../common/components/Grid'
import Typography from 'material-ui/Typography'
import TextField from 'material-ui/TextField'
import Paper from 'material-ui/Paper'
import IconButton from 'material-ui/IconButton'
import ArrowBackIcon from 'material-ui-icons/ArrowBack'
import Tabs, {Tab} from 'material-ui/Tabs'
import queryString from 'querystring'
import LoadingButton from '../../common/components/LoadingButton'

import {connect} from 'react-redux'
import {Recover as RecoverHandler} from '../../state/login/actions'
import styles from './styles'
import {recover as text} from './text'

class Recover extends React.Component {

  constructor(props) {
    super(props)

    const step = this.pickTab(props.location.search)
    this.props.setStep(step)
    this.loadUrlData(step, props.location.search)

  }

  pickTab = (search) => {
    const parsed = queryString.parse(search.substr(1, search.length))

    let step = 0

    if (parsed.step && (parsed.step === '1' || parsed.step === '2')) {
      step = parseInt(parsed.step, 10) - 1
    }

    return step
  }

  loadUrlData = (step, search) => {
    const parsed = queryString.parse(search.substr(1, search.length))

    if (step === 0) {
      if (parsed.email) {
        this.props.step1SetEmail(parsed.email)
      }
    }
    if (step === 1) {
      if (parsed.email) {
        this.props.step2SetEmail(parsed.email)
      }
      if (parsed.code) {
        this.props.step2SetCode(parsed.code)
      }
    }
  }

  handleBackClick = () => {
    this.props.history.goBack()
  }

  handleChangeTab = (e, v) => {
    this.props.setStep(v)
  }

  handleSendCodeClick = (e) => {
    e.preventDefault()
    this.props.handleSendCodeClick()
  }

  handleSendNewPasswordClick = (e) => {
    e.preventDefault()
    this.props.handleSendNewPasswordClick()
  }

  renderStepOne = classes => (
    <div className={classes.step}>
      <Grid container direction="column">
        <Grid item xs={12} safariFix={true}>
          <Typography variant="display1">{text.step1.title}</Typography>
        </Grid>
        <Grid item xs={12} safariFix={true}>
          <Typography variant="body1">{text.step1.body}</Typography>
        </Grid>
        <Grid item xs={12} safariFix={true}>
          <TextField
            value={this.props.step1Email}
            autoFocus={this.props.step === 0}
            id="email"
            label={text.step1.labelEmail}
            className={classes.textField}
            type="email"
            autoComplete="email"
            error={this.props.step1EmailError !== ''}
            helperText={this.props.step1EmailError}
            onChange={e => this.props.step1SetEmail(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} safariFix={true}>
          <div className={classes.buttonContainer}>
            <LoadingButton
              variant="raised"
              color="primary"
              isLoading={this.props.step1IsFetching}
              onClick={this.handleSendCodeClick}
              type="submit"
            >
              {text.step1.sendCode}
            </LoadingButton>
          </div>
        </Grid>
        {
          this.props.step1Error !== '' &&
          <Grid item xs={12} safariFix={true}>
            <Typography className={classes.error}>{this.props.step1Error}</Typography>
          </Grid>
        }
      </Grid>
    </div>
  )

  renderStepTwo = classes => (
    <div className={classes.step}>
      <Grid container direction="column">
        <Grid item xs={12} safariFix={true}>
          <Typography variant="display1">{text.step2.title}</Typography>
        </Grid>
        <Grid item xs={12} safariFix={true}>
          <Typography variant="body1">{text.step2.body}</Typography>
        </Grid>
        <Grid item xs={12} safariFix={true}>
          <TextField
            value={this.props.step2Email}
            id="email"
            label={text.step2.labelEmail}
            className={classes.textField}
            type="email"
            autoComplete="email"
            autoFocus={this.props.step === 1}
            error={this.props.step2EmailError !== ''}
            helperText={this.props.step2EmailError}
            onChange={e => this.props.step2SetEmail(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} safariFix={true}>
          <TextField
            value={this.props.step2Code}
            id="code"
            label={text.step2.labelCode}
            className={classes.textField}
            type="text"
            error={this.props.step2CodeError !== ''}
            helperText={this.props.step2CodeError}
            onChange={e => this.props.step2SetCode(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} safariFix={true}>
          <TextField
            id="password"
            type="password"
            label={text.step2.labelNewPassword}
            className={classes.textField}
            autoComplete="new-password"
            error={this.props.step2PasswordError !== ''}
            helperText={this.props.step2PasswordError}
            onChange={e => this.props.step2SetPassword(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} safariFix={true}>
          <div className={classes.buttonContainer}>
            <LoadingButton
              variant="raised"
              color="primary"
              isLoading={this.props.step2IsFetching}
              onClick={this.handleSendNewPasswordClick}
              type="submit"
            >
              {text.step2.accept}
            </LoadingButton>
          </div>
        </Grid>
        {
          this.props.step2Error !== '' &&
          <Grid item xs={12} safariFix={true}>
            <Typography className={classes.error}>{this.props.step2Error}</Typography>
          </Grid>
        }
      </Grid>
    </div>
  )

  render() {
    const {classes} = this.props
    return (
      <div className={classes.root}>
        <div className={classes.logo}>
          <img src="/assets/logo.png" alt="logo" className={classes.logoImg}/>
        </div>
        <Paper className={classes.container}>
          <form noValidate autoComplete="off">
            <IconButton className={classes.backButton} onClick={this.handleBackClick}><ArrowBackIcon/></IconButton>
            <Tabs
              value={this.props.step}
              onChange={this.handleChangeTab}
              indicatorColor="primary"
              fullWidth
            >
              <Tab label={text.step1.label}/>
              <Tab label={text.step2.label}/>
            </Tabs>
            {this.props.step === 0 ? this.renderStepOne(classes) : null}
            {this.props.step === 1 ? this.renderStepTwo(classes) : null}
          </form>
        </Paper>
      </div>
    )
  }
}

Recover.propTypes = {
  step: PropTypes.number,
  setStep: PropTypes.func,
  step1Email: PropTypes.string,
  step1EmailError: PropTypes.string,
  step1IsFetching: PropTypes.bool,
  step1Error: PropTypes.string,
  step1SetEmail: PropTypes.func,
  handleSendCodeClick: PropTypes.func,
  step2Email: PropTypes.string,
  step2EmailError: PropTypes.string,
  step2Password: PropTypes.string,
  step2PasswordError: PropTypes.string,
  step2Code: PropTypes.string,
  step2CodeError: PropTypes.string,
  step2IsFetching: PropTypes.bool,
  step2Error: PropTypes.string,
  step2SetEmail: PropTypes.func,
  step2SetPassword: PropTypes.func,
  step2SetCode: PropTypes.func,
  handleSendNewPasswordClick: PropTypes.func,
}

const mapStateToProps = state => {
  const login = state.ui.login
  return {
    step: login.recover.step,
    step1Email: login.recover.step1Email,
    step1EmailError: login.recover.step1EmailError,
    step1IsFetching: login.recover.step1IsFetching,
    step1Error: login.recover.step1Error,
    step2Email: login.recover.step2Email,
    step2EmailError: login.recover.step2EmailError,
    step2Password: login.recover.step2Password,
    step2PasswordError: login.recover.step2PasswordError,
    step2Code: login.recover.step2Code,
    step2CodeError: login.recover.step2CodeError,
    step2IsFetching: login.recover.step2IsFetching,
    step2Error: login.recover.step2Error,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setStep: step => dispatch(RecoverHandler.setStep(step)),
    step1SetEmail: email => dispatch(RecoverHandler.step1SetEmail(email)),
    handleSendCodeClick: () => dispatch(RecoverHandler.step1SendCode()),
    step2SetEmail: email => dispatch(RecoverHandler.step2SetEmail(email)),
    step2SetPassword: password => dispatch(RecoverHandler.step2SetPassword(password)),
    step2SetCode: code => dispatch(RecoverHandler.step2SetCode(code)),
    handleSendNewPasswordClick: code => dispatch(RecoverHandler.step2SendNewPassword(code)),
  }
}

const Container = connect(mapStateToProps, mapDispatchToProps)(Recover)
const StyledRecover = withStyles(styles, {withTheme: true})(Container)

export default StyledRecover



// WEBPACK FOOTER //
// ./src/sections/recover/Recover.js